import React, {
  useEffect,
  useState,
} from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import {
  Autocomplete,
  Button as MUIButton,
  Popper,
  TextField,
} from '@mui/material';
import { enumItems } from '../../../schema/enumItems';
import CircularProgress from '@mui/material/CircularProgress';
import api from '../../../services/api';
import { toaster } from '../../../services/toaster';

const CustomPopper = function (props: any) {
  return (
    <>
      <div>
        <Popper
          {...props}
          sx={{
            '& .MuiPaper-root': {
              boxShadow: '0 4px 10px -1px rgb(17 20 24 / 20%)',
            },
          }}
          style={{
            width: 'fit-content',
            maxWidth: '300px',
          }}
          placement="bottom-start"
        />
      </div>
    </>
  );
};

export const SetRolesDialog = ({
  checkedRows,
  onSubmit,
  onClose,
}: {
  checkedRows: any;
  onClose: () => void;
  onSubmit: () => void;
}) => {
  const [loadingInput, setLoadingInput] = useState(false);
  const [selectOptions, setSelectOptions] = useState<any>([]);
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState<any>([]);

  useEffect(() => {
    const roles: any = [];

    Object.keys(checkedRows).map((key) => {
      const row = checkedRows[key];

      row.roles.map((roleItem: any) => {
        console.log(roleItem);

        if (!roles.some((role: any) => role.id === roleItem.id)) {
          roles.push(roleItem);
        }
      });
    });

    setValue(roles);
  }, [checkedRows]);

  const fetchSelectOptions = async (searchText: string) => {
    setLoadingInput(true);

    let string: any = {
      searchValue: searchText,
    };
    const searchParams = new URLSearchParams(string);

    enumItems.userType.client.readAll(1, searchParams).then((result: any) => {
      setSelectOptions(result?.data);
      setLoadingInput(false);
    });
  };

  const handleOpen = () => {
    setOpen(true);
    (async () => {
      await fetchSelectOptions('');
    })();
  };

  const handleClose = () => {
    setOpen(false);
    setSelectOptions([]);
  };

  return (
    <>
      <Dialog
        open={true}
        onClose={() => {
          onClose();
        }}
      >
        <DialogTitle>Select roles to update</DialogTitle>
        <DialogContent
          sx={{
            pt: '6px!important',
          }}
        >
          <Autocomplete
            multiple
            PopperComponent={CustomPopper}
            options={selectOptions}
            open={open}
            onOpen={handleOpen}
            onClose={handleClose}
            value={value}
            getOptionLabel={(option: any) => {
              let text = option?.name;
              return text;
            }}
            isOptionEqualToValue={(option, value) => {
              if (!option?.id) return false;
              return option.id === value.id;
            }}
            loading={loadingInput}
            sx={{
              minWidth: '200px',
            }}
            onChange={(event, newValue) => {
              setValue(newValue);
            }}
            renderInput={(params) => {
              return (
                <TextField
                  {...params}
                  size="small"
                  label={'Roles'}
                  InputLabelProps={{
                    style: {
                      fontSize: 13,
                      paddingTop: 2,
                    },
                  }}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {loadingInput ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              );
            }}
          />
        </DialogContent>
        <DialogActions>
          <MUIButton
            onClick={() => {
              onClose();
            }}
          >
            Cancel
          </MUIButton>
          <MUIButton
            variant={'contained'}
            color={'error'}
            onClick={() => {
              api
                .post('/set-user-roles', {
                  checked_rows: JSON.stringify(checkedRows),
                  roles: JSON.stringify(value),
                })
                .then((res: any) => {
                  onSubmit();
                  toaster.show({
                    intent: 'success',
                    message: `Successfully saved roles`,
                  });
                })
                .catch((e: any) => {
                  toaster.show({
                    icon: 'error',
                    message: `Error: error while saving roles`,
                    intent: 'danger',
                  });
                });
            }}
            autoFocus
          >
            Submit
          </MUIButton>
        </DialogActions>
      </Dialog>
    </>
  );
};
